import { listDetailsActionTypes } from './Constants';

export function getListDetailsRequest(id) {
	return {
		type: listDetailsActionTypes.GET_LIST_DETAILS_REQUEST,
		payload: {
			id,
		},
	};
}

export function getListDetailsSuccess(data) {
	return {
		type: listDetailsActionTypes.GET_LIST_DETAILS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getListDetailsError() {
	return {
		type: listDetailsActionTypes.GET_LIST_DETAILS_ERROR,
	};
}

export function getListResultsRequest(id, fromResultsPage) {
	return {
		type: listDetailsActionTypes.GET_LIST_RESULTS_REQUEST,
		payload: {
			id,
			fromResultsPage,
		},
	};
}

export function getListResultsSuccess(listResults) {
	return {
		type: listDetailsActionTypes.GET_LIST_RESULTS_SUCCESS,
		payload: {
			listResults,
		},
	};
}

export function getListResultsError() {
	return {
		type: listDetailsActionTypes.GET_LIST_RESULTS_ERROR,
	};
}

export function toggleAddListModal(addListModalStatus, addListModalType) {
	return {
		type: listDetailsActionTypes.TOGGLE_ADD_LIST_MODAL,
		payload: {
			addListModalStatus,
			addListModalType,
		},
	};
}

export function addListRequest(id, list, type, itemType) {
	return {
		type: listDetailsActionTypes.ADD_LIST_REQUEST,
		payload: {
			type,
			id,
			list,
			itemType,
		},
	};
}

export function addListSuccess() {
	return {
		type: listDetailsActionTypes.ADD_LIST_SUCCESS,
		payload: {},
	};
}

export function addListError() {
	return {
		type: listDetailsActionTypes.ADD_LIST_ERROR,
		payload: {},
	};
}

export function duplicateListRequest(id, force = false) {
	return {
		type: listDetailsActionTypes.DUPLICATE_LIST_REQUEST,
		payload: {
			id,
			force,
		},
	};
}

export function duplicateListSuccess(listResults) {
	return {
		type: listDetailsActionTypes.DUPLICATE_LIST_SUCCESS,
		payload: {
			listResults,
		},
	};
}

export function duplicateListError() {
	return {
		type: listDetailsActionTypes.DUPLICATE_LIST_ERROR,
	};
}

export function updateListRequest(id, listData) {
	return {
		type: listDetailsActionTypes.UPDATE_LIST_REQUEST,
		payload: {
			id,
			listData,
		},
	};
}

export function updateListSuccess(listData) {
	return {
		type: listDetailsActionTypes.UPDATE_LIST_SUCCESS,
		payload: {
			listData,
		},
	};
}

export function updateListError() {
	return {
		type: listDetailsActionTypes.UPDATE_LIST_ERROR,
	};
}

export function toggleConfirmationModal(status) {
	return {
		type: listDetailsActionTypes.TOGGLE_CONFIRMATION_MODAL,
		payload: {
			status,
		},
	};
}

export function deleteListRequest(id, isFromList = false, isUserQuiz = false, callback) {
	return {
		type: listDetailsActionTypes.DELETE_LIST_REQUEST,
		payload: {
			id,
			isFromList,
			isUserQuiz,
			callback,
		},
	};
}

export function deleteListSuccess() {
	return {
		type: listDetailsActionTypes.DELETE_LIST_SUCCESS,
	};
}

export function deleteListError() {
	return {
		type: listDetailsActionTypes.DELETE_LIST_ERROR,
	};
}

export function clearListDetails() {
	return {
		type: listDetailsActionTypes.CLEAR_LIST_DETAILS,
	};
}

export function setListStatus(status) {
	return {
		type: listDetailsActionTypes.SET_LIST_STATUS,
		payload: {
			status,
		},
	};
}

export function toggleCopyListModal(data) {
	return {
		type: listDetailsActionTypes.TOGGLE_COPY_LIST_MODAL,
		payload: {
			data,
		},
	};
}

export function getListSongsRequest(listId) {
	return {
		type: listDetailsActionTypes.GET_LIST_SONGS_REQUEST,
		payload: {
			listId,
		},
	};
}

export function getListSongsSuccess(songs) {
	return {
		type: listDetailsActionTypes.GET_LIST_SONGS_SUCCESS,
		payload: {
			songs,
		},
	};
}

export function getListSongsError() {
	return {
		type: listDetailsActionTypes.GET_LIST_SONGS_ERROR,
	};
}

export function deleteSongRequest(listId, songId) {
	return {
		type: listDetailsActionTypes.DELETE_SONG_REQUEST,
		payload: {
			listId,
			songId,
		},
	};
}

export function deleteSongSuccess(songsData) {
	return {
		type: listDetailsActionTypes.DELETE_SONG_SUCCESS,
		payload: {
			songsData,
		},
	};
}

export function deleteSongError() {
	return {
		type: listDetailsActionTypes.DELETE_SONG_ERROR,
	};
}
